import { useController } from 'react-hook-form';

import {
  Input,
  InputHelperText,
  InputLabel,
  InputProps,
  InputRoot,
  InputWithCounter,
} from '@mint-lib/tw-components';

type Props = {
  fieldName: string;
  label: string;
  dataTestId?: string;
  tooltipText?: string;
} & InputProps;

export const InputField = ({
  fieldName,
  label,
  dataTestId,
  tooltipText,
  ...props
}: Props) => {
  const controller = useController({
    name: fieldName,
  });

  const InputComponent = props.maxLength ? InputWithCounter : Input;

  return (
    <InputRoot className="flex w-full flex-col">
      {label && (
        <InputLabel
          htmlFor={fieldName}
          label={label}
          infoIconWithTooltip={tooltipText}
        />
      )}
      <InputComponent
        type={props.type || 'text'}
        name={fieldName}
        id={fieldName}
        value={controller.field.value}
        onChange={controller.field.onChange}
        onBlur={controller.field.onBlur}
        data-testid={dataTestId}
        className="w-full"
        {...props}
        maxLength={props.maxLength || 100}
      />
      {controller.fieldState.error?.message && (
        <InputHelperText
          color="error"
          helperText={controller.fieldState.error?.message}
        />
      )}
    </InputRoot>
  );
};
